import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSubscript20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSubscript20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
                <path strokeLinejoin="round" d="m2.727 14.772 9.546-9.545m-9.545 0 9.545 9.546" />
                <path d="m15.68 12.297 1.576-.357v4.4" />
            </g>
        </svg>
    );
}
export default memo(IconSubscript20);
